import React from "react";
import "./palvelut.css";
import { useMediaQuery } from "react-responsive";

function Palvelut() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const Text1 = (
    <div className="box text-box" key="t1">
      <h2>Testamentit, perunkirjoitukset ja pesänjaot</h2>
      <p>
        Tiedätkö, mitä mahdollisuuksia sinulla on määrätä jäämistöstäsi?
        Testamentti ei ole vain iäkkäiden henkilöiden asia, vaan esimerkiksi
        silloin, kun olet eronnut, asut avoliitossa tai uusperheessä, on
        järkevää usein tehdä testamentti. Myös lasten puolisoiden avio-oikeus halutaan usein eron varalta rajata
        pois testamentilla.
      </p>
      <p>
         Jos perhettänne kohtaa läheisen poismeno, olen
        halutessanne apunanne perunkirjoituksen hoitamisessa. Tarvittavien
        asiakirjojen hankkiminen kannattaa aloittaa hyvissä ajoin, niiden
        saamisessa voi usein kestää. Aikaa perunkirjoituksen tekoon on 3 kk.
        Ota yhteyttä, niin lähetän listan perukirjaa varten tarvittavista
        asiakirjoista.
      </p>
    </div>
  );

  const Img1 = (
    <div className="box image-box" key="i1">
      <img src="/perunkirjat.png" alt="testamentti" />
    </div>
  );

  const Img2 = (
    <div className="box image-box" key="i2">
      <img src="/edunvalvonta.png" alt="edunvalvonta" />
    </div>
  );

  const Text2 = (
    <div className="box text-box" key="t2">
      <h2>Edunvalvontavaltakirjat</h2>
      <p>
        Edunvalvontaa tarvitaan, kun henkilö ei pysty jostain syystä hoitamaan
        asioitaan. Yleinen edunvalvonta on erittäin ruuhkautunutta, joten
        edunvalvontavaltakirjan tekeminen hyvissä ajoin on järkevää.
        Edunvalvontavaltakirjassa voi valtuuttaa läheisensä hoitamaan asioita
        sitten, kun itse ei enää pysty. Valtakirja tulee voimaan vasta, kun
        lääkäri toteaa toimintakyvyn laskeneen ja valtakirja rekisteröidään.
      </p>
    </div>
  );

  const Text3 = (
    <div className="box text-box" key="t3">
      <h2>Avioehdot ja ositukset</h2>
      <p>
        Avioehdon voi tehdä avioliittoa solmittaessa tai sen aikana. Jos
        avioehtoa ei ole tehty eikä omaisuutta ole rajattu avio-oikeuden
        ulkopuolelle esimerkiksi testamentilla, aviopuolisoiden omaisuuden
        yhteismäärä jaetaan avioeron kohdatessa puoliksi. Mikäli toisella
        puolisoista on esimerkiksi suvussa pitkään kulkenutta omaisuutta, on
        sellaisen rajaaminen avioehdolla avio-oikeuden ulkopuoliseksi
        omaisuudeksi usein järkevää.
      </p>
    </div>
  );

  const Img3 = (
    <div className="box image-box" key="i3">
      <img src="/avioehto.png" alt="avioehto" />
    </div>
  );

  //järjestykset: desktop vs. mobiili 
  const desktopOrder = [Text1, Img1, Img2, Text2, Text3, Img3];
  const mobileOrder   = [Text1, Img1, Text2, Img2, Text3, Img3];

  return (
    <div>
      <main>
        <div className="image-div">
          <div className="first_image">
            <img src="/elamasiasiakirjat.png" alt="elamasiasiakirjat" />
          </div>
        </div>

        {

        }
        <div className="content-wrapper">
          <div className="content-grid palvelut">
            {(isMobile ? mobileOrder : desktopOrder).map((el) => el)}
          </div>
        </div>
      </main>
    </div>
  );
}

export default Palvelut;
